import { render, staticRenderFns } from "./DepartmentSelector.vue?vue&type=template&id=197e65ae&scoped=true&"
import script from "./DepartmentSelector.vue?vue&type=script&lang=ts&"
export * from "./DepartmentSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentSelector.vue?vue&type=style&index=0&id=197e65ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e65ae",
  null
  
)

export default component.exports